// extracted by mini-css-extract-plugin
module.exports = {"control-input":"style_control-input__BTLgZ"};